module.exports = __webpack_public_path__ + "img/Huawei.201b77aa.jpg";